import { render, staticRenderFns } from "./TodoDashboard.vue?vue&type=template&id=dbc3d2fe&scoped=true&"
import script from "./TodoDashboard.vue?vue&type=script&lang=js&"
export * from "./TodoDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TodoDashboard.vue?vue&type=style&index=0&id=dbc3d2fe&lang=scss&scoped=true&"
import style1 from "./TodoDashboard.vue?vue&type=style&index=1&lang=scss&"
import style2 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc3d2fe",
  null
  
)

export default component.exports